'use client';

import {useSearchParams, usePathname} from 'next/navigation';
import {useRouter} from 'next/navigation';
import {useEffect} from 'react';

declare global {
  interface Window {
    OneTrust?: {
      ToggleInfoDisplay: () => void;
    };
  }
}

export default function ConsentTrigger() {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    if (searchParams.get('showConsent') === 'true' && window.OneTrust) {
      window.OneTrust.ToggleInfoDisplay();

      const params = new URLSearchParams(searchParams.toString());
      params.delete('showConsent');
      const query = params.toString();
      router.replace(query ? `${pathname}?${query}` : pathname, {scroll: false});
    }
  }, [searchParams, pathname, router]);

  return null;
}
